import { useEffect, useMemo } from 'react';
import { Autocomplete, Box, Card, CardContent, CircularProgress, Grid, TextField, Button } from '@mui/material';
import { ExpandMoreRounded } from '@mui/icons-material';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';

import { Main, Next, BodyMediumMedium600, DarkGreyTextLarge } from './Location.styles';

import { MapPin } from '../SvgComponents';
import { useInputValue } from '../../hooks/useInputValue';
import { stockApi } from '../../store/domains/stock';

const Location = ({ control, handleSubmit }) => {
  const [location, handleChangelocation] = useInputValue('');

  const { data: locations, isLoading } = stockApi.useGetLocationsQuery(location || 'N');

  const handleChangeAddress = (onChange, data) => {
    onChange(
      {
        name: data?.name ?? '',
        address: data?.address ?? '',
        longitude: data?.longitude ?? 0,
        latitude: data?.latitude ?? 0,
      } ?? null
    );
  };

  return (
    <Main>
      <Card sx={{ mt: 3 }}>
        <CardContent sx={{ p: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <BodyMediumMedium600>Location</BodyMediumMedium600>
              <Controller
                name="address"
                control={control}
                rules={{ required: true }}
                render={({ field: { ref, onChange, ...field }, fieldState: { error } }) => (
                  <Autocomplete
                    {...field}
                    //   sx={{ width: 300 }}
                    options={locations || []}
                    getOptionLabel={(option) => option.address ?? ''}
                    inputValue={location}
                    popupIcon={<ExpandMoreRounded />}
                    isOptionEqualToValue={(option, value) => option.address === value.address}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        sx={{ mt: 1.5 }}
                        error={!!error}
                        helperText={error && 'Locaiton required'}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {isLoading && <CircularProgress color="inherit" size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        <Box sx={{ height: 24, mr: 2 }}>
                          <MapPin className="icon--primary" />
                        </Box>
                        <DarkGreyTextLarge>{option.label}</DarkGreyTextLarge>
                      </Box>
                    )}
                    onInputChange={handleChangelocation}
                    onChange={(_, obj) => {
                      handleChangeAddress(onChange, obj);
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Main>
  );
};

Location.defaultProps = {
  progress: undefined,
};

export default Location;
